import React, { createContext, useContext, useState, useCallback } from 'react';
import SignInDialog from '../components/SignInDialog';

const SignInDialogContext = createContext(null);

export const useSignInDialog = () => {
  const ctx = useContext(SignInDialogContext);
  if (!ctx) throw new Error('useSignInDialog must be used inside <SignInDialogProvider>');
  return ctx;
};

export const SignInDialogProvider = ({ children }) => {
  const [state, setState] = useState({ open: false, mode: 'signin' });

  const open = useCallback((mode = 'signin') => setState({ open: true, mode }), []);
  const onOpenChange = useCallback((next) => setState((s) => ({ ...s, open: next })), []);

  return (
    <SignInDialogContext.Provider value={{ open }}>
      {children}
      <SignInDialog open={state.open} onOpenChange={onOpenChange} initialMode={state.mode} />
    </SignInDialogContext.Provider>
  );
};
